import API from "../../../../../global/api";
import jsPDF from "jspdf";
// import moment from "moment";
import _ from "lodash";
import { PDFHeader } from "../../../../../global/globalFunctions";


export const requestCashBookPDF = () => {
    return {
        type: "REQUEST_CASHBOOK_PDF",
    };
};
export const successCashBookPDF = (data) => {
    return {
        type: "SUCCESS_CASHBOOK_PDF",
        payload: data,
    };
};
export const errorCashBookPDF = () => {
    return {
        type: "ERROR_CASHBOOK_PDF",
    };
};
export const CashBookPDFApi = (data) => {
    return (dispatch) => {
        dispatch(requestCashBookPDF());
        API.post(`/reports/cash_book_report`, data).then((res) => {
            let data1 = res.data;
            let getData = res.data.data;
            let dataD = _.filter(getData, { credit: 0 })
            let dataC = _.filter(getData, { debit: 0 })

            const unit = "pt";
            const size = "A4";
            const orientation = "p";
            const doc = new jsPDF(orientation, unit, size);
            PDFHeader(doc, "CashBook Report");

            const dataDebit = dataD.map((x, i) => [x.voucherDate, x.vocManualNumber, x.voucherDescription, x.debit])
            const dataCredit = dataC.map((x, i) => [x.voucherDate, x.vocManualNumber, x.voucherDescription, x.credit])

            doc.setFontSize(12);
            doc.setFont("Times New Roman", "normal")
            doc.text(`Account Name: ${data1.levelFourName}`, 50, 130, 0, 20);
            doc.text(`Date From: ${data.startDate} - Date To: ${data.endDate}`, 50, 145, 0, 20);
            doc.text(`Todal Credit: ${data1.creditSum}`, 400, 145, 0, 20);
            doc.text(`Todal Debit: ${data1.debitSum}`, 400, 160, 0, 20);
            doc.text(`Opening Balance: ${getData[0].closingBalance} ${getData[0].openingBalanceSign}`, 50, 160, 0, 20);
            doc.text(`Closing Balance: ${data1.closing_balance} ${data1.closing_balance_sign || ''}`, 50, 175, 0, 20);

            const headersDebit = [["DATE", "VOUCHER ID", "NARRATION", "AMOUNT DR"]];
            let contentDebit = {
                startY: 190,
                startX: 10,
                head: headersDebit,
                theme: 'grid',
                headStyles: {
                    fillColor: [13, 110, 253]
                },
                body: dataDebit
            };
            dataDebit.push([
                "",
                { content: "TOTAL", colSpan: 1, styles: { halign: "left", fontStyle: "bold" } },
                "",
                { content: parseFloat(_.sumBy(dataDebit, '3').toFixed()), styles: { halign: "left", fontStyle: "bold" } },
            ])
            doc.autoTable(contentDebit);

            const headerCredit = [["DATE", "VOUCHER ID", "NARRATION", "AMOUNT CR"]];
            let contentCredit = {
                startY: doc.lastAutoTable.finalY + 20,
                startX: 10,
                head: headerCredit,
                theme: 'grid',
                headStyles: {
                    fillColor: [13, 110, 253]
                },
                body: dataCredit
            };
            dataCredit.push([
                "",
                { content: "TOTAL", colSpan: 1, styles: { halign: "left", fontStyle: "bold" } },
                "",
                { content: parseFloat(_.sumBy(dataCredit, '3').toFixed()), styles: { halign: "left", fontStyle: "bold" } },
            ])
            doc.autoTable(contentCredit);

            doc.setLineWidth(2);
            doc.line(150, doc.lastAutoTable.finalY + 70, 40, doc.lastAutoTable.finalY + 70);
            doc.text("Prepared By", 60, doc.lastAutoTable.finalY + 85, 0, 0)
            doc.setLineWidth(2);
            doc.line(240, doc.lastAutoTable.finalY + 70, 350, doc.lastAutoTable.finalY + 70)
            doc.text("Checked By", 265, doc.lastAutoTable.finalY + 85, 0, 0)
            doc.setLineWidth(2);
            doc.line(430, doc.lastAutoTable.finalY + 70, 540, doc.lastAutoTable.finalY + 70)
            doc.text("Approved By", 455, doc.lastAutoTable.finalY + 85, 0, 0)


            doc.setProperties({ title: `CashBook Report` });
            var blob = doc.output("blob");
            window.open(URL.createObjectURL(blob));

            dispatch(successCashBookPDF(getData));
        }).catch((error) => {
            dispatch(errorCashBookPDF());
        })
    };
};